import { useContext, useEffect } from 'react';

import { isProdNodeEnv } from '@rover/rsdk/src/modules/Env/node';

import type { ToastRecord } from './Toast.common';
import ToastContext from './ToastContext';

export const DOUBLE_STACK_WARNING =
  '<ToastStack> is drawing the toasts its <ToastProvider> already draws, so every toast appears twice. Drop this stack and call useToast(), or call useToastList() for a list of its own.';

/** The provider renders its own stack outside its context, so only a screen's stack lands here. */
const useDoubleStackWarning = (toasts: readonly ToastRecord[]): void => {
  const provided = useContext(ToastContext);
  const isDrawingProvidedList = provided?.toasts === toasts;

  useEffect(() => {
    if (!isDrawingProvidedList || isProdNodeEnv()) return;

    // eslint-disable-next-line no-console
    console.warn(DOUBLE_STACK_WARNING);
  }, [isDrawingProvidedList]);
};

export default useDoubleStackWarning;
